import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const DataImporters = lazy(() => import('es/app/views/site/data-importers'));
const EditDataImporter = lazy(() => import('es/app/views/site/data-importers/edit'));
const DataImporterExecutionLogsGrid = lazy(
    () => import('es/app/views/site/data-importers/edit/execution-logs/DataImporterExecutionLogsGrid')
);
const DataImporterConfigurationForm = lazy(
    () => import('es/app/views/site/data-importers/edit/configuration/DataImportersConfigurationForm')
);

export function DataImporterRoutes() {
    return (
        <Route path={siteMap.dataImporters.search()} element={<DataImporters />} ErrorBoundary={RouteErrorBoundary}>
            <Route path={siteMap.dataImporters.create()} element={<EditDataImporter />}>
                <Route index element={<DataImporterConfigurationForm />} />
            </Route>
            <Route path={siteMap.dataImporters.edit().root} element={<EditDataImporter />}>
                <Route index element={<DataImporterConfigurationForm />} />
                <Route
                    path={siteMap.dataImporters.edit().logs}
                    element={<DataImporterExecutionLogsGrid excludeColumns={['dataImporter.name']} />}
                />
            </Route>
        </Route>
    );
}
